import React from "react-native";
import { useTheme } from "../../theme";
import { TooltipIcon } from "./tooltip-icon";
import { IconProps } from "../icon";

export function TooltipErrorIcon({
    title,
    size,
    style,
}: {
    title: string;
    size?: IconProps["size"];
    style?: IconProps["style"];
}) {
    const theme = useTheme();
    return (
        <TooltipIcon
            icon="error"
            color={theme.colors.error}
            title={title}
            style={style}
            size={size}
        />
    );
}
